import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSL: CultureInfo = {
  name: 'en-SL',
  displayName: 'English (Sierra Leone)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SL',
  parent: CultureInfoEn
};
